import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let referral_professional_id = useDataValue({
    context: 'profile_patient_referral',
    path: 'person_id',
    viewPath: props.viewPath,
  })

  return {
    variables: { referral_professional_id },
  }
}
